exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".upload-btn{height:40px;border-style:solid;border-width:2px;border-radius:3px;background:#fff;position:relative;margin-top:20px;margin-bottom:10px}.upload-area{text-align:center;padding-top:7px;font-size:15px;font-weight:800}#upload-file{cursor:pointer;font-size:30px;outline:medium 0;position:absolute;filter:alpha(opacity=0);-moz-opacity:0;opacity:0;left:0;top:0;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/file-uploader.vue
// module id = 52
// module chunks = 0